import { Component, h } from "preact";

export interface ITouchCTLProps {
   click?: () => void;
   longclick?: () => void;
   context?: () => void;
}

const MIN_TOUCH = 10;

export default class TouchCTL extends Component<ITouchCTLProps> {
   touch = false;
   startPos: { x: number; y: number };
   timeout: any;
   right = false;

   start: Date;

   constructor(props, ctx) {
      super(props, ctx);
      this.onStart = this.onStart.bind(this);
      this.onEnd = this.onEnd.bind(this);
      this.cancel = this.cancel.bind(this);
      this.onContext = this.onContext.bind(this);
   }

   onContext(evt: MouseEvent) {
      evt.preventDefault();
      if (this.props.context) this.props.context();
   }

   onStart(evt: TouchEvent | MouseEvent) {
      if ((evt as MouseEvent).button == 2) {
         this.right = true;
      } else if ((evt as MouseEvent).button == 0 || evt instanceof TouchEvent) {
         if (this.timeout) clearTimeout(this.timeout);

         this.touch = true;
         this.start = new Date();
         this.timeout = setTimeout(() => {
            this.timeout = undefined;
            if (this.props.longclick) this.props.longclick();
         }, 1000);
      }
   }

   onEnd(evt: TouchEvent | MouseEvent) {
      if (evt.cancelable) evt.preventDefault();

      if ((evt as MouseEvent).button == 2) {
         if (this.right) {
            this.right = false;
            if (this.props.context) this.props.context();
         }
      } else if ((evt as MouseEvent).button == 0 || evt instanceof TouchEvent) {
         if (this.touch) {
            if (this.timeout) {
               clearTimeout(this.timeout);
               console.log(new Date().valueOf() - this.start.valueOf());
               if (
                  this.start &&
                  new Date().valueOf() - this.start.valueOf() > MIN_TOUCH
               ) {
                  console.log("Click");
                  if (this.props.click) this.props.click();
               }
            }

            this.touch = false;
         }
      }
   }

   cancel(evt: MouseEvent | TouchEvent | UIEvent) {
      if (this.timeout) clearTimeout(this.timeout);
      this.touch = false;
   }

   componentWillMount() {
      window.addEventListener("scroll", this.cancel);
   }
   componentWillUnmount() {
      window.removeEventListener("scroll", this.cancel);
   }

   render() {
      return (
         <div
            onTouchStart={this.onStart}
            onTouchEnd={this.onEnd}
            onTouchMove={this.cancel}
            onMouseDown={this.onStart}
            onMouseUp={this.onEnd}
            // onMouseOut={this.cancel}
            // onMouseMove={this.cancel}
            onScroll={this.cancel}
            onContextMenuCapture={this.onContext}
            onClick={(evt) => evt.preventDefault()}
            onContextMenu={(evt) => evt.preventDefault()}
         >
            {this.props.children}
         </div>
      );
   }
}
